import { render } from "./MatchTable.vue?vue&type=template&id=4534d87a&scoped=true"
import script from "./MatchTable.vue?vue&type=script&lang=js"
export * from "./MatchTable.vue?vue&type=script&lang=js"

import "./MatchTable.vue?vue&type=style&index=0&id=4534d87a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4534d87a"]])

export default __exports__